module.exports = __webpack_public_path__ + "512868b0ff465bfd1b8ffb556795de96.jpeg";